import React, { createContext, useState } from 'react';

export const DeviceMetricsContext = createContext({});

export const DeviceMetricsProvider = (props) => {
    const [refreshTimestamp, setRefreshTimestamp] = useState(Date.now());

    const refreshMetrics = () => {
        setRefreshTimestamp(Date.now());
    };

    const value = {
        refreshMetrics,
        refreshTimestamp
    };

    return (
        <DeviceMetricsContext.Provider value={value}>
            {props.children}
        </DeviceMetricsContext.Provider>
    );
};